import React, { useMemo, useState } from "react";
import APP_CONFIG from "../../../../../config/appConfig";
import ContactPsycikModal from "./contactPsycikModal";

function ContactCardForNudge({ contact, headClass, avatarClass }) {
  const {
    contact_name = "",
    role = "",
    decision_level = "",
    linkedin_profile = "",
    why_relevant = "",
    psychographic_profile_summary,
  } = contact || {};
  // Memoize avatar URL
  const avatarUrl = useMemo(
    () =>
      `${
        APP_CONFIG.AVATAR_URL
      }background=${avatarClass}&color=fff&name=${encodeURIComponent(
        contact_name
      )}&rounded=true&bold=true&font-size=0.50`,
    [contact_name, avatarClass]
  );
  const [show, setShow] = useState(false);
  const onClick = () => {
    setShow(true);
  };

  const onClose = () => {
    setShow(false);
  };
  return (
    <>
      <div style={{ margin: "2vh" }}>
        <div className="col-md-12">
          <div className="contact_tile">
            <div className={`contact_icon_block ${headClass}`} />

            {psychographic_profile_summary && (
              <div
                onClick={onClick}
                style={{
                  position: "absolute",
                  top: "0.5rem",
                  right: "0.5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  maxWidth: "9vw",
                  maxHeight: "3vh",
                  color: "#64748B",
                  border: "1px solid #E2E8F0",
                  padding: "0.4rem",
                  borderRadius: "0.5rem",
                  fontSize: "0.92rem",

                  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.29)",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  ":hover": {
                    transform: ` translateX(-100px) !important`,
                    backgroundColor: "#F8FAFC",
                    borderColor: "#CBD5E1",
                  },
                }}
              >
                <img
                  src="/img/profile.png"
                  style={{
                    height: "1.25rem",
                    width: "1.25rem",
                    borderRadius: "50%",
                    marginRight: "0.5rem",
                    objectFit: "cover",
                  }}
                  alt="Profile"
                />
                <span>View Profile</span>
              </div>
            )}
            <div className="contact_block">
              <div className="Key_icon_block">
                <img
                  className="contact_icon_img"
                  src={avatarUrl}
                  alt="Avatar"
                  loading="lazy"
                />
              </div>

              <h5 className="contact_head">{contact_name}</h5>

              <p className="contact_info_para">{role}</p>

              <p className="contact_info_para state">{decision_level}</p>

              <p className="contact_info_para">{why_relevant}</p>

              {/* <div className="d-flex linked_email_block">
                {linkedin_profile && (
                  <a
                    href={linkedin_profile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="email_link"
                  >
                    <i className="fa fa-linkedin-square" aria-hidden="true" />{" "}
                    Profile
                  </a>
                )}
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {show && (
        <ContactPsycikModal data={contact} show={show} onClose={onClose} />
      )}
    </>
  );
}

export default React.memo(ContactCardForNudge);
